import JSvgSingle from './Control_Svg'
export { JSvgSingle }
export default JSvgSingle